const { settingsActions } = require('@redux/slices/settings');
const { getAppDispatch } = require('@utilities/dispatch.util');

const settingDataManipulation = ({ data }) => {
  const settings = Object.keys(data).reduce((acc, curr) => {
    let value = data[curr];
    value = curr.endsWith('DisplayFields') ? (value ? value.join(',') : '') : value;
    acc[curr] = value;
    return acc;
  }, data);

  return { settings };
};

const settingDataDispatcher = ({ data }) => {
  const dispatch = getAppDispatch();

  dispatch?.(settingsActions.setSettings(data?.settings));
};

export { settingDataManipulation, settingDataDispatcher };
